const createTransactionFilePath = ({
  companyId, realtorId, clientId, fileName,
}) => `${companyId}/${realtorId}/${clientId}/${fileName}`;

const createTaskFilePath = ({ id, fileName }) => `${id}/${fileName}`;

const createCompanyLogoPath = ({ companyId, fileName }) => `${companyId}/${fileName}`;

const createTemplateFilePath = ({ templateId, fileName }) => `${templateId}/${fileName}`;

export {
  createTransactionFilePath,
  createTaskFilePath,
  createCompanyLogoPath,
  createTemplateFilePath,
};
